<template>
    <v-fab
        class="report-button"
        icon="icon-bug"
        color="#3FB8D7"
        size="x-small"
        :style="style"
        @click="dialogOpen = !dialogOpen"
    />
    <ReportDialog
        v-if="dialogOpen"
        v-model="dialogOpen"
    />
</template>

<script setup lang="ts">
import { computed, ref, type StyleValue, watch } from 'vue';

import ReportDialog from '../reportDialog/ReportDialog.vue';

import { type Languages, useTranslations } from '../../composables';

export interface ReportButtonProps {
    language: Languages;
};

const props = defineProps<ReportButtonProps>();

const { languageCode } = useTranslations();

const dialogOpen = ref(false);

const style = computed((): StyleValue => {
    let right = 12;
    if (import.meta.env.VITE_ENABLE_BETA === 'true') {
        right += 36;
    }
    return {
        '--right': `${right}px`
    };
});

watch(() => props.language, (): void => {
    languageCode.value = props.language;
}, { immediate: true });
</script>

<style scoped lang="scss">
@use 'ReportButton.scss';
</style>